import helpers from '../../../Utils/helpers'
import system from '../../../Constants/system';
import { useTranslation } from 'react-i18next';

export default function CompensationBlikkProducts({ products, onClick }) {
    const { t } = useTranslation();

    const handleProductClick = (item) => {
        const product = {
            product: item.productDescription,
            name: item.productDescription,
            sourceSystem: system.Blikk,
            period: null,
            users: null,
            api: null,
        };
        onClick(product);
    };

    return (
        <fieldset className="col-xs-12">
            <legend>{t('compensationblikkproduct.header')}</legend>
            <div className="table-container">
                <table className="table table-stripe table-hover table-saas-products">
                    <thead>
                        <tr>
                            <th className="text-left">{t('compensationblikkproduct.program')}</th>
                            <th className="text-left">{t('compensationblikkproduct.purchasedate')}</th>
                            <th className="text-left">{t('compensationblikkproduct.enddate')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((item, index) =>
                            <tr key={index} onClick={() => handleProductClick(item)}>
                                <td className="text-left">{item.productDescription}</td>
                                <td className="text-left">{helpers.formatDate(item.activationDate)}</td>
                                <td className="text-left">{helpers.formatDate(item.currentPeriodEndDate)}</td>
                            </tr>)
                        }
                    </tbody>
                </table>
            </div>
        </fieldset>
    )
}